import type { StoreProductData } from '@legacy/common-ui-models';
import type { TextField } from '@sitecore-jss/sitecore-jss-angular';

import { abbreviationForInterval } from './abbreviation-for-interval';

export function getProductSuffixLabel(
  product: StoreProductData,
  sitecoreSuffixLabel: TextField
): TextField {
  return product.isSubscription
    ? { value: `/${abbreviationForInterval(product.subscriptionInterval)}` }
    : sitecoreSuffixLabel;
}
